export default __webpack_public_path__ + "static/expedia-offer-0950c581bb4fc82ce6e54ab785bcb80f.webp";